import { render, staticRenderFns } from "./QuestionBox.vue?vue&type=template&id=70a8fab5&"
import script from "./QuestionBox.vue?vue&type=script&lang=js&"
export * from "./QuestionBox.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBox.vue?vue&type=style&index=0&id=70a8fab5&prod&scooped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports